module.exports = __webpack_public_path__ + "static/media/addMemberGuide2.20098204.png";